import { FC, SVGProps } from 'react';

export const CameraIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M23.7414 13.334C23.7414 13.8639 23.3114 14.294 22.7814 14.294C22.2515 14.294 21.8214 13.8639 21.8214 13.334C21.8214 12.8041 22.2515 12.3369 22.7814 12.3369C23.3114 12.3369 23.7414 12.7285 23.7414 13.2585V13.334ZM16.1587 22.3721C13.4464 22.3721 11.2397 20.1653 11.2397 17.453C11.2397 14.7407 13.4464 12.534 16.1587 12.534C18.871 12.534 21.0778 14.7407 21.0778 17.453C21.0778 20.1653 18.871 22.3721 16.1587 22.3721ZM23.785 9.0639C23.3203 9.04598 22.8877 8.85142 22.5766 8.5263C22.5203 8.46358 22.2925 8.1807 21.7613 7.18486C21.1507 6.0431 19.968 5.33398 18.6752 5.33398H13.6678C12.3955 5.33398 11.2218 6.02646 10.6074 7.14006C10.048 8.15254 9.81632 8.45078 9.7536 8.5199C9.43232 8.85526 8.99968 9.0511 8.55936 9.0703C6.048 9.0703 4.00384 11.1132 4 13.6245V20.8463C4 24.0975 6.64576 26.7433 9.89568 26.7433H22.4243C25.6755 26.7433 28.32 24.0975 28.32 20.8463V13.622C28.32 11.1081 26.2746 9.0639 23.785 9.0639Z'
			fill='currentColor'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M16.1592 14.4531C14.5054 14.4531 13.1602 15.7984 13.1602 17.4522C13.1602 19.1059 14.5054 20.4512 16.1592 20.4512C17.8129 20.4512 19.1582 19.1059 19.1582 17.4522C19.1582 15.7984 17.8129 14.4531 16.1592 14.4531Z'
			fill='currentColor'
		/>
	</svg>
);
